module.exports = __webpack_public_path__ + "ColabLig.e9995e88a2a868277a85.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/colaborate/ColabLig.woff
// module id = ../../../../../src/assets/font/colaborate/ColabLig.woff
// module chunks = 2